export default __webpack_public_path__ + "static/media/puppyMaleBlue.77c15c4d.jpg";